import { render, staticRenderFns } from "./expected_student_file_form.vue?vue&type=template&id=410a4c6c&scoped=true&"
import script from "./expected_student_file_form.vue?vue&type=script&lang=ts&"
export * from "./expected_student_file_form.vue?vue&type=script&lang=ts&"
import style0 from "./expected_student_file_form.vue?vue&type=style&index=0&id=410a4c6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a4c6c",
  null
  
)

export default component.exports